import React from 'react';
import { Step1 } from './Step1';

const HomePage = () => {	
	return (
		<>
			<Step1 />			
		</>
	);
};

export default HomePage;
